import backendVerifiedUser from '../../api/backendVerifiedUser';
import {
  GET_PLUGINS,
  GET_PLUGIN,
  PLUGINS_LOADING,
  PLUGINS_SUCCESS,
  PLUGINS_ERROR,
} from '../Types/PluginsTypes';

export const getPlugins = () => async (dispatch) => {
  dispatch({ type: PLUGINS_LOADING });
  try {
    const res = await backendVerifiedUser.get('/plugins');
    dispatch({ type: GET_PLUGINS, payload: res.data.integrations || res.data.plugins || [] });
  } catch (err) {
    dispatch({ type: PLUGINS_ERROR, payload: err.response?.data?.error?.msg || 'Failed to load plugins' });
  }
};

export const getPlugin = (key) => async (dispatch) => {
  dispatch({ type: PLUGINS_LOADING });
  try {
    const res = await backendVerifiedUser.get(`/plugins/${key}`);
    dispatch({ type: GET_PLUGIN, payload: res.data.plugin });
  } catch (err) {
    dispatch({ type: PLUGINS_ERROR, payload: err.response?.data?.error?.msg || 'Failed to load plugin' });
  }
};

export const savePluginSettings = (key, settings) => async (dispatch) => {
  dispatch({ type: PLUGINS_LOADING });
  try {
    const res = await backendVerifiedUser.post(`/plugins/${key}/settings`, { settings });
    dispatch({ type: PLUGINS_SUCCESS, payload: res.data.success?.msg });
    // Refresh plugin data
    dispatch(getPlugin(key));
  } catch (err) {
    dispatch({ type: PLUGINS_ERROR, payload: err.response?.data?.error?.msg || 'Failed to save settings' });
  }
};

export const togglePlugin = (key) => async (dispatch) => {
  dispatch({ type: PLUGINS_LOADING });
  try {
    const res = await backendVerifiedUser.post(`/plugins/${key}/toggle`);
    dispatch({ type: PLUGINS_SUCCESS, payload: res.data.success?.msg });
    dispatch(getPlugin(key));
  } catch (err) {
    dispatch({ type: PLUGINS_ERROR, payload: err.response?.data?.error?.msg || 'Failed to toggle plugin' });
  }
};

export const testMetaEvent = (eventName, testEventCode) => async (dispatch) => {
  dispatch({ type: PLUGINS_LOADING });
  try {
    const res = await backendVerifiedUser.post('/plugins/meta-ads/test-event', { eventName, testEventCode });
    dispatch({ type: PLUGINS_SUCCESS, payload: 'Test event sent successfully!' });
    return res.data;
  } catch (err) {
    dispatch({ type: PLUGINS_ERROR, payload: err.response?.data?.error?.msg || 'Test event failed' });
    return null;
  }
};
